import Parse from 'html-react-parser';

function BMP20273(props) {

    let svgCode =
    `<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3H43V36C43 39.866 39.866 43 36 43H3V3Z" fill="${props.highlightColour}" stroke="white" stroke-width="2"/>
        <path d="M36 23H33.5L30 15.5L23.5 30.5L20.5 23L15 23" stroke="white" stroke-width="2"/>
        <path d="M9 23L16 28.1962L16 17.8038L9 23Z" fill="white"/>
    </svg>`

    props.svgReturn(49, svgCode, "bmp00273", 46, 46);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20273;